import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './ManagerUsers.module.css';
import { setView } from '../../modules/explorer';
import { Tabs, TabList, Tab } from 'react-tabs';
import { getUsers } from '../../modules/users';
import TableView from '../../components/TableView';

class ManagerUsers extends Component {
  state = {
    selectedIndex: 0,
    headers: ['User', 'Role', 'Company', ''],
  };

  componentDidMount() {
    const { setView } = this.props;
    setView({
      page: 'userview',
      catogary: 'users',
      activeLabel: 'manage',
    });
  }

  componentWillUnmount() {
    const { setView } = this.props;
    setView({
      page: null,
      catogary: null,
      activeLabel: null,
    });
  }

  onSelect = idx => this.setState({ selectedIndex: idx });

  render() {
    const { selectedIndex, headers } = this.state;
    return (
      <div className={styles.container}>
        <div className={styles.header}> Manage Users</div>
        <div className={styles.content}>
          <Tabs onSelect={this.onSelect} selectedIndex={selectedIndex}>
            <TabList>
              {[
                'Members',
                'Administrators',
                'Managers',
                'Modelers',
                'Reviewers',
              ].map(v => (
                <Tab
                  style={{
                    width: '16%',
                    height: 40,
                    textAlign: 'center',
                    borderRadius: 0,
                  }}
                >
                  <span className={styles.tabTitle}>{v}</span>
                </Tab>
              ))}
            </TabList>
          </Tabs>
          <TableView
            headers={headers}
            data={[
              [
                'Ziyang',
                'User',
                'Threekit',
                { label: 'Remove User', color: '#2375C2', pointer: true },
              ],
              [
                'Ziyang2',
                'Modeler',
                'Crate and Barrel',
                { label: 'Remove User', color: '#2375C2' },
              ],
              [
                'Ziyang2',
                'Modeler',
                'Crate and Barrel',
                { label: 'Remove User', color: '#2375C2' },
              ],
              [
                'Ziyang2',
                'Modeler',
                'Crate and Barrel',
                { label: 'Remove User', color: '#2375C2' },
              ],
              [
                'Ziyang2',
                'Modeler',
                'Crate and Barrel',
                { label: 'Remove User', color: '#2375C2' },
              ],
            ]}
            rowColor="#2375C2"
            onClick={this.openViewPage}
            onHeaderClick={this.onHeaderClick}
          />
        </div>
      </div>
    );
  }
}

const stateToProps = state => ({
  users: getUsers(state),
});

export default connect(
  stateToProps,
  { setView, getUsers }
)(ManagerUsers);



// WEBPACK FOOTER //
// ./src/containers/ManagerUsers/index.js